var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 8.99806L0.5 0.5V6.01163C1.1707 6.01163 1.77936 5.76938 2.25427 5.37209C2.79703 4.91473 3.54914 4.80233 4.18107 5.12403L11.8088 8.99612L4.18107 12.8682C3.5472 13.1899 2.79703 13.0775 2.25427 12.6202C1.77936 12.2209 1.16876 11.9806 0.5 11.9806V17.5L17.5 9V8.99806Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepWhite);
export default __webpack_public_path__ + "static/media/step-white.a3239d7e5e8161ebd5de5300888752e6.svg";
export { ForwardRef as ReactComponent };